export default "__VITE_ASSET__DtL0Peiy__"